import { PaymentDuesRepository } from "@/repositories/payment-dues.repository";
import { IndividualPaymentDue } from "./payment-dues.entity";
import { PaymentDueReport } from "@/app/vendors/payment-dues/payment-dues.entity";
import {
  createPaymentSheet,
  type CreatePaymentSheetPayload,
  type CreatePaymentSheetResponse,
} from "@/services/stripe-subs-payments.service";
import {
  finalizeStripePaymentDue,
  type FinalizeStripePaymentDueResponse,
} from "@/services/payment-dues-functions.service";

export async function getIndividualPaymentDues(): Promise<IndividualPaymentDue[]> {
  return PaymentDuesRepository.getIndividualPaymentDuesForSubs();
}

export async function markIndividualPaymentDuesAsPaid(individualId: string): Promise<void> {
  return PaymentDuesRepository.markDuesPaid("individual", individualId);
}

export async function getIndividualPaymentDueReport(individualId: string): Promise<PaymentDueReport> {
  return PaymentDuesRepository.getIndividualPaymentDueReportForSubs(individualId);
}

export async function createStripePaymentForIndividualDue(
  payload: CreatePaymentSheetPayload
): Promise<CreatePaymentSheetResponse> {
  return createPaymentSheet(payload);
}

export async function finalizeStripePaymentForIndividualDue(
  individualId: string,
  paymentIntentId: string
): Promise<FinalizeStripePaymentDueResponse> {
  return finalizeStripePaymentDue({
    kind: "due",
    recipientType: "individual",
    recipientId: individualId,
    paymentIntentId,
  });
}
